import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  createHttpLink,
} from "@apollo/client/core";

import { createAuthLink } from "aws-appsync-auth-link";
import { createSubscriptionHandshakeLink } from "aws-appsync-subscription-link";

const url =
  "https://agxlhr3v7nfdnhfv3ssxsfdcpe.appsync-api.us-east-1.amazonaws.com/graphql";
const region = "us-east-1";

const httpLink = createHttpLink({ uri: url });

const link = ApolloLink.from([
  createAuthLink({
    url,
    region,
    auth: {
      type: "API_KEY",
      apiKey: "da2-6tvpydp6kvci7gu7w6ud27gvqy",
    },
  }),
  createSubscriptionHandshakeLink(
    {
      url,
      region,
      auth: {
        type: "API_KEY",
        apiKey: "da2-6tvpydp6kvci7gu7w6ud27gvqy",
      },
    },
    httpLink
  ),
]);

export const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});
